import React from "react";
import {
  MDBContainer,
  MDBInput,
  MDBCol,
  MDBRow,
  MDBBtn,
} from "mdb-react-ui-kit";
import Form from "react-bootstrap/Form";
import { DatePickerComponent } from "Projects/CC_cubi_clan_project/GlobalComponents/DatePickerComponent/DatePickerComponent";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { CategoriaSuggestionModal } from "Projects/CCON_cubiconta_project/Components/CategoriaSuggestionModal/CategoriaSuggestionModal";

class TransactionForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.data,
      mapaCategorias: props.mapaCategorias || [],
      categoriaSearch: "",
      nuevaCategoria: "",
      nuevaCategoriaColor: "#607d8b",
      mostrarCampoNuevaCategoria: false,
      errorCategoria: "",
      mostrarOpcionesAvanzadas: !!(props.data?.fechaImputacion),
      categoriaSuggestionState: null, // { suggestions, categoria, event }
    };
  }

  componentDidMount() {
    this.getAllCategorias();
  }

  getAllCategorias() {
    this.props.onLoading(true);

    return doFetch("CCON", "getAllCategorias", null)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const categorias = (data.STATE === "SUCCESS" && Array.isArray(data.DATA)) ? data.DATA : [];
        this.setState({ mapaCategorias: categorias });
        if (categorias.length > 0) {
          const dataTransaccion = { ...this.state.data };
          if (!dataTransaccion.IDCategoriaFK?.IDCategoria) {
            dataTransaccion.IDCategoriaFK.IDCategoria = categorias[0].IDCategoria;
          }
          const selected = categorias.find(
            (c) => String(c.IDCategoria) === String(dataTransaccion.IDCategoriaFK.IDCategoria)
          );
          // Fallback: use embedded category name from transaction data if not in user's list
          const fallbackNombre = this.state.data?.IDCategoriaFK?.nombre || "";
          this.setState({
            data: dataTransaccion,
            categoriaSearch: selected?.nombre || fallbackNombre,
          });
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  handleChange = (event) => {
    let data = { ...this.state.data }; // Crear una copia del estado para mantener inmutabilidad
    const { id, value } = event.target;

    switch (id) {
      case "cuentaTransaccion": {
        const accountId = value ? parseInt(value, 10) : null;
        data.cuentas = [
          {
            participacion: 100.0,
            IDCuentaFK: { IDCuenta: accountId },
          },
        ];
        break;
      }
      case "categoriaSearch": {
        const match = (this.state.mapaCategorias || []).find(
          (c) => (c.nombre || "").toLowerCase() === (value || "").trim().toLowerCase()
        );
        if (match) {
          data.IDCategoriaFK.IDCategoria = match.IDCategoria;
        }
        this.setState({ categoriaSearch: value, mostrarCampoNuevaCategoria: false });
        break;
      }
      case "cantidad":
        const filteredValue = value.replace(/[^0-9.-]/g, "");
        const parts = filteredValue.split(".");
        const formattedValue =
          parts.length > 2
            ? parts[0] + "." + parts.slice(1).join("")
            : filteredValue;
        const finalValue = formattedValue.startsWith("-")
          ? "-" + formattedValue.slice(1).replace(/-/g, "")
          : formattedValue.replace(/-/g, "");
        const finalValue2 = finalValue.startsWith(".")
          ? finalValue.slice(1)
          : finalValue;
        const finalValue3 = finalValue2 === "" ? 0 : finalValue2;
        data[id] = finalValue3;
        break;
      case "nuevaCategoria":
        this.setState({ nuevaCategoria: value });
        break;
      case "nuevaCategoriaColor":
        this.setState({ nuevaCategoriaColor: value });
        break;
      case "fechaImputacion":
        // value viene como "YYYY-MM" desde input type=month → guardar día 1
        data.fechaImputacion = value ? `${value}-01` : null;
        break;
      default:
        data[id] = value;
        break;
    }

    this.setState({ data }, () => {
      this.props.onChange(data);
    });
  };

  async doSubmit(event) {
    if (!this.state.data.concepto) {
      alert("El concepto es obligatorio");
      return;
    }

    if (this.state.mostrarCampoNuevaCategoria) {
      if (!this.state.nuevaCategoria.trim()) {
        alert("La nueva categoría no puede estar vacía");
        return;
      }

      const categoriaExiste = this.state.mapaCategorias.some(
        (categoria) =>
          categoria.nombre.toLowerCase() ===
          this.state.nuevaCategoria.trim().toLowerCase()
      );

      if (categoriaExiste) {
        alert("Categoría ya existente");
        return;
      }

      const nuevaCategoria = {
        nombre: this.state.nuevaCategoria.trim(),
        color: this.state.nuevaCategoriaColor || "#607d8b",
      };
      await this._handleInsertCategoriaConSuggestion(nuevaCategoria, event);
      return;
    }

    this.props.onSubmit(event);
  }

  async _handleInsertCategoriaConSuggestion(categoria, event) {
    this.props.onLoading(true);
    const suggestions = await doFetch("CCON", "searchSimilarCategorias", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ nombre: categoria.nombre }),
    })
      .then((r) => r.json())
      .then((data) => data.DATA?.sugerencias || [])
      .catch(() => [])
      .finally(() => this.props.onLoading(false));

    if (suggestions.length > 0) {
      this.setState({ categoriaSuggestionState: { suggestions, categoria, event } });
    } else {
      await this._finalizarInsertCategoria(categoria.nombre, categoria.color, null, event);
    }
  }

  async _finalizarInsertCategoria(nombre, color, idCategoriaSugerida, event) {
    const categoriaPayload = { nombre, color };
    if (idCategoriaSugerida != null) categoriaPayload.IDCategoriaSugerida = idCategoriaSugerida;

    const result = await this.insertCategoria(categoriaPayload);

    if (!result) {
      alert("Error al guardar la nueva categoría");
      return;
    }

    await this.getAllCategorias();
    const catCreada = (this.state.mapaCategorias || []).find((c) =>
      idCategoriaSugerida != null
        ? String(c.IDCategoria) === String(idCategoriaSugerida)
        : c.nombre?.toLowerCase() === nombre.toLowerCase()
    );
    if (catCreada?.IDCategoria) {
      const data = { ...this.state.data };
      data.IDCategoriaFK.IDCategoria = catCreada.IDCategoria;
      this.setState({ data, categoriaSearch: catCreada.nombre });
    }
    this.setState({
      mostrarCampoNuevaCategoria: false,
      nuevaCategoria: "",
      nuevaCategoriaColor: "#607d8b",
      categoriaSuggestionState: null,
    });
    this.props.onSubmit(event);
  }

  onCatSuggestionUseExisting(IDCategoria, Nombre) {
    const { categoriaSuggestionState } = this.state;
    if (!categoriaSuggestionState) return;
    this.setState({ categoriaSuggestionState: null }, () => {
      this._finalizarInsertCategoria(
        categoriaSuggestionState.categoria.nombre,
        categoriaSuggestionState.categoria.color,
        IDCategoria,
        categoriaSuggestionState.event
      );
    });
  }

  onCatSuggestionCreateAnyway() {
    const { categoriaSuggestionState } = this.state;
    if (!categoriaSuggestionState) return;
    this.setState({ categoriaSuggestionState: null }, () => {
      this._finalizarInsertCategoria(
        categoriaSuggestionState.categoria.nombre,
        categoriaSuggestionState.categoria.color,
        null,
        categoriaSuggestionState.event
      );
    });
  }

  onCatSuggestionCancel() {
    this.setState({ categoriaSuggestionState: null });
  }

  async insertCategoria(categoria) {
    let result = false;

    this.props.onLoading(true);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify([categoria]),
    };

    await doFetch("CCON", "insertCategorias", requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al insertar la categoría:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  getCategoriaSuggestions = (query) => {
    const q = (query || "").trim().toLowerCase();
    const all = this.state.mapaCategorias || [];
    const filtered = q
      ? all.filter((c) => (c.nombre || "").toLowerCase().includes(q))
      : all;
    return filtered.slice(0, 6);
  };

  render() {
    const { categoriaSuggestionState } = this.state;
    const categoriaSugeridas = this.getCategoriaSuggestions(this.state.categoriaSearch);
    const categoriaActiva = (this.state.mapaCategorias || []).find(
      (c) => String(c.IDCategoria) === String(this.state.data.IDCategoriaFK.IDCategoria)
    );
    return (
      <>
        {categoriaSuggestionState && (
          <CategoriaSuggestionModal
            suggestions={categoriaSuggestionState.suggestions}
            nombrePropuesto={categoriaSuggestionState.categoria.nombre}
            onUseExisting={(id, nombre) => this.onCatSuggestionUseExisting(id, nombre)}
            onCreateAnyway={() => this.onCatSuggestionCreateAnyway()}
            onCancel={() => this.onCatSuggestionCancel()}
          />
        )}
      <MDBContainer
        fluid={!!this.props.fullWidth}
        breakpoint={this.props.fullWidth ? undefined : "sm"}
        className={this.props.compactMode ? "transaction-form-compact" : ""}
      >
        {this.props.conceptosSugeridos && this.props.conceptosSugeridos.length > 0 && (
          <datalist id="concepto-suggestions">
            {this.props.conceptosSugeridos.map((c, i) => (
              <option key={i} value={c} />
            ))}
          </datalist>
        )}
        <MDBRow className="g-2">
          {Array.isArray(this.props.accountOptions) && this.props.accountOptions.length > 0 && (
            <MDBCol size="12">
              <Form.Label htmlFor="cuentaTransaccion" className="small mb-1">Cuenta asociada</Form.Label>
              <select
                id="cuentaTransaccion"
                className="form-select mb-2"
                value={this.state.data?.cuentas?.[0]?.IDCuentaFK?.IDCuenta || ""}
                onChange={(event) => this.handleChange(event)}
              >
                {this.props.accountOptions.map((acc) => (
                  <option key={acc.id} value={acc.id}>{acc.nombre}</option>
                ))}
              </select>
            </MDBCol>
          )}
          <MDBCol size="12">
            <DatePickerComponent
              className="mb-2"
              id="fecha"
              label="Fecha"
              value={this.state.data.fecha}
              tabIndex={1}
              onChange={(event) => this.handleChange(event)}
            />
          </MDBCol>
        </MDBRow>

        <MDBRow className="g-2">
          <MDBCol size="12">
            <MDBInput
              className="mb-2"
              type="text"
              id="concepto"
              label="Concepto"
              list="concepto-suggestions"
              value={this.state.data.concepto}
              tabIndex={2}
              onChange={(event) => this.handleChange(event)}
            />
          </MDBCol>
        </MDBRow>

        <MDBRow className="g-2">
          <MDBCol size="12">
            <MDBInput
              className="mb-2"
              type="text"
              id="detalle"
              label="Detalle"
              value={this.state.data.detalle}
              tabIndex={3}
              onChange={(event) => this.handleChange(event)}
            />
          </MDBCol>
        </MDBRow>

        <MDBRow className="g-2">
          <MDBCol size="12">
            <MDBInput
              className="mb-2"
              type="text"
              id="cantidad"
              label="Cantidad"
              value={this.state.data.cantidad}
              tabIndex={4}
              onChange={(event) => this.handleChange(event)}
            />
          </MDBCol>
        </MDBRow>

        <MDBRow className="g-2">
          <MDBCol size="12">
            <Form.Label htmlFor="categoria" className="small mb-1">Categoría</Form.Label>
            <div className="d-flex align-items-center gap-2">
              <span
                style={{
                  display: "inline-block",
                  width: 18,
                  height: 18,
                  borderRadius: "50%",
                  flexShrink: 0,
                  backgroundColor: categoriaActiva?.color || "#aaaaaa",
                }}
              />
              <input
                className="form-control"
                id="categoriaSearch"
                type="text"
                list="categoria-suggestions"
                value={this.state.categoriaSearch}
                placeholder="Buscar categoría..."
                tabIndex={5}
                onChange={(event) => this.handleChange(event)}
                autoComplete="off"
              />
              <datalist id="categoria-suggestions">
                {categoriaSugeridas.map((element) => (
                  <option key={element.IDCategoria} value={element.nombre} />
                ))}
              </datalist>
              <MDBBtn
                color="secondary"
                outline
                size="sm"
                type="button"
                tabIndex={6}
                onClick={() => this.setState({ mostrarCampoNuevaCategoria: true })}
              >
                Nueva
              </MDBBtn>
            </div>
            <div className="mb-2" />
          </MDBCol>
        </MDBRow>
        {this.state.mostrarCampoNuevaCategoria && (
          <MDBRow className="g-2">
            <MDBCol size="12">
              <MDBInput
                className="mb-2"
                type="text"
                id="nuevaCategoria"
                label="Nueva Categoría"
                value={this.state.nuevaCategoria}
                tabIndex={7}
                onChange={(event) => this.handleChange(event)}
              />
            </MDBCol>
            <MDBCol size="12">
              <div className="d-flex align-items-center gap-2 mb-2">
                <Form.Label htmlFor="nuevaCategoriaColor" className="mb-0">
                  Color
                </Form.Label>
                <input
                  id="nuevaCategoriaColor"
                  type="color"
                  value={this.state.nuevaCategoriaColor}
                  tabIndex={8}
                  onChange={(event) => this.handleChange(event)}
                  style={{ width: 36, height: 30, padding: 0, border: "none", background: "transparent" }}
                />
                <small className="text-muted">{this.state.nuevaCategoriaColor}</small>
              </div>
            </MDBCol>
          </MDBRow>
        )}
        {/* ── Opciones avanzadas: Mes contable ── */}
        <MDBRow>
          <MDBCol size="12">
            <div
              className="d-flex align-items-center gap-2 mb-2"
              style={{ cursor: "pointer", userSelect: "none" }}
              onClick={() => this.setState((s) => ({ mostrarOpcionesAvanzadas: !s.mostrarOpcionesAvanzadas }))}
            >
              <small className="text-muted">
                {this.state.mostrarOpcionesAvanzadas ? "▾" : "▸"} Opciones avanzadas
              </small>
              {this.state.data.fechaImputacion && !this.state.mostrarOpcionesAvanzadas && (
                <small className="text-info">(mes contable activo)</small>
              )}
            </div>
            {this.state.mostrarOpcionesAvanzadas && (
              <div className="p-3 border rounded mb-3" style={{ background: "#f8f9fa" }}>
                <Form.Label htmlFor="fechaImputacion" className="small fw-semibold mb-1">
                  Mes contable
                </Form.Label>
                <div className="small text-muted mb-2">
                  Si este gasto pertenece a un mes distinto al de su fecha bancaria, indícalo aquí.
                  Ejemplo: hipoteca de febrero cobrada a finales de enero.
                </div>
                <input
                  type="month"
                  id="fechaImputacion"
                  className="form-control"
                  value={
                    this.state.data.fechaImputacion
                      ? this.state.data.fechaImputacion.slice(0, 7)
                      : ""
                  }
                  tabIndex={9}
                  onChange={(event) => this.handleChange(event)}
                />
                {this.state.data.fechaImputacion && (
                  <button
                    type="button"
                    className="btn btn-link btn-sm p-0 mt-1 text-danger"
                    tabIndex={10}
                    onClick={() => {
                      const data = { ...this.state.data, fechaImputacion: null };
                      this.setState({ data }, () => this.props.onChange(data));
                    }}
                  >
                    Quitar mes contable
                  </button>
                )}
              </div>
            )}
          </MDBCol>
        </MDBRow>
        {!this.props.hideSubmitButton && (
          <div className="d-flex gap-2">
            <MDBBtn onClick={(event) => this.doSubmit(event)} block>
              {this.props.submitLabel || "Guardar"}
            </MDBBtn>
            {this.props.onProrratear && (
              <MDBBtn
                color="warning"
                outline
                onClick={(event) => this.props.onProrratear(event, this.state.data)}
                block
              >
                {this.props.prorratearLabel || "Guardar y prorratear"}
              </MDBBtn>
            )}
          </div>
        )}
      </MDBContainer>
      </>
    );
  }
}

export default TransactionForm;
